import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { withStyles, Container } from '@material-ui/core';

import* as generalAction from "../../actions/general";
import styles from './styles';
import ProjectItem from '../../components/ProjectItem';
import SearchItem from '../../components/SearchItem';

function SearchPage(props) {
  const { classes, keySearchState, generalActionCreators, searchContent } = props;
  const { fetchSearchAction } = generalActionCreators;

  const seoData = {
    seo_title: "Tin tức cập nhật mới nhất",
    seo_description: "Chúng tôi luôn cập nhất mới nhất về các thông tin công nghệ hàng ngày, phong phú và đa dạng",
    name: "Công ty TNHH thiết kế và lập trình website, app mobile Wasth"
  }

  useEffect(() => {
    if(keySearchState !== ""){
      fetchSearchAction(keySearchState)
    }
  }, [fetchSearchAction, keySearchState]);

  const renderProject = () => {
    if(searchContent.data && searchContent.data.project.data.length > 0){
      const projectData = searchContent.data.project.data;
      return projectData.map(item => <ProjectItem key={item.id} item={item} seoNews={seoData} />);
    }
  }
  
  const renderNews = () => {
    if(searchContent.data && searchContent.data.news.length > 0){
      const newsData = searchContent.data.news;
      return newsData.map(item => <SearchItem key={item.id} item={item}/>);
    }
  }

  return (
    <>
      {searchContent.data ?
      <Container className={classes.root}>
        <div className={classes.title}>
          <h3>Kết quả tìm kiếm cho từ khóa: {keySearchState}</h3>
        </div>
        <div className={classes.project}>
          <div className='title'>
            <h3>Các dự án đã hoàn thành</h3>
          </div>
          <div className='content'>
            {renderProject()}
          </div>
        </div>
        <div className={classes.other}>
          <div className='title'>
          <h3>Các nội dung liên quan</h3>
          </div>
          <div className='content'>
            {renderNews()}
          </div>
        </div>
      </Container>
      :
      <Container >
        <div className={classes.noContent}><p>Nội dung tìm kiếm không tồn tại !!</p></div>
      </Container> 
      }
    </>
  );
}

const mapStateToProps = state => {
  return {
    keySearchState: state.general.keySearch,
    searchContent: state.general.searchContent,
  }
};

const mapDispatchToProps = dispatch => ({
  generalActionCreators: bindActionCreators(generalAction, dispatch)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(SearchPage);